import React from 'react';
import * as classnames from 'classnames';

import Title from '../Title';
import { Arrow } from '../../static';

import './styles.scss';

const AccordionItem = ({item, index, toggleItem, isBorderNon}) => {
	return (
		<div
			key={index}
            onClick={() => toggleItem(index)}
            className={
				classnames('accordion-item', {
					'accordion-item--open': item.open,
					'accordion-item--border-non': isBorderNon,
				})
			}
		>

			<div className="accordion-item__title">
                <Title text={item.title} isTexStart isLight isBold />
                <div className="accordion-item__icon">
                    <Arrow />
                </div>
			</div>
			<div className="accordion-item__content">
				{item.text}
			</div>
		</div>
	);
};

export default AccordionItem;